import { gql } from '@apollo/client'

export const CREATE_PARTNER = gql`
  mutation CreatePartner($input: CreatePartnerInput!) {
    createPartner(input: $input) {
      id
    }
  }
`

export const ADD_PARTNER_CONTACTS = gql`
  mutation AddPartnerContacts($partnerId: UUID!, $input: CreatePartnerContactsInput!) {
    createPartnerContacts(id: $partnerId, input: $input)
  }
`
export const DELETE_PARTNER_CONTACTS = gql`
  mutation DeletePartnerContacts($partnerId: UUID!, $input: DeletePartnerContactsInput!) {
    deletePartnerContacts(id: $partnerId, input: $input)
  }
`
export const CHANGE_PARTNER_CONTACTS = gql`
  mutation ChangePartnerContacts($partnerId: UUID!, $input: ChangePartnerContactsInput!) {
    changePartnerContacts(id: $partnerId, input: $input)
  }
`
export const ADD_PARTNER_BANK_DATA = gql`
  mutation AddPartnerBankData($partnerId: UUID!, $input: ChangePartnerBankDetailsInput!) {
    changePartnerBankDetails(id: $partnerId, input: $input)
  }
`
export const ADD_PARTNER_DOCUMENTS = gql`
  mutation AddPartnerDocuments($id: UUID!, $input: AddPartnerDocumentsInput!) {
    addPartnerDocuments(id: $id, input: $input)
  }
`

export const REMOVE_PARTNER_DOCUMENTS = gql`
  mutation RemovePartnerDocuments($id: UUID!, $input: RemovePartnerDocumentsInput!) {
    removePartnerDocuments(id: $id, input: $input)
  }
`

export const CHANGE_PARTNER_TAX_INFORMATION = gql`
  mutation ChangePartnerTaxInformation($id: UUID!, $input: ChangePartnerTaxInformationInput!) {
    changePartnerTaxInformation(id: $id, input: $input)
  }
`

export const CHANGE_PARTNER_KAM_USER = gql`
  mutation ChangePartnerKAMUser($id: UUID!, $input: ChangePartnerKAMUserInput!) {
    changePartnerKAMUser(id: $id, input: $input)
  }
`

export const CHANGE_PARTNER_DETAILS = gql`
  mutation ChangePartnerDetails($id: UUID!, $input: ChangePartnerDetailsInput!) {
    changePartnerDetails(id: $id, input: $input)
  }
`

export const DEACTIVATE_PARTNER = gql`
  mutation DeactivatePartner($id: UUID!, $input: DeactivatePartnerInput!) {
    deactivatePartner(id: $id, input: $input)
  }
`

export const ACTIVATE_PARTNER = gql`
  mutation ActivatePartner($id: UUID!) {
    activatePartner(id: $id)
  }
`
